// extracted by mini-css-extract-plugin
export default {"linkNav":"navbar_linkNav__Vkdw7"};